import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export default class DeviceService {
  private deviceSubject = new BehaviorSubject<string>(null);
  public device$ = this.deviceSubject.asObservable();

  public setDevice(device: string) {
    this.deviceSubject.next(device);
  }

  public eq(device: string): boolean {
    return this.deviceSubject.getValue() == device;
  }

  public gt(device: string): boolean {
    if(device == 'sm') {
      return ['md', 'lg', 'xl'].indexOf(this.deviceSubject.getValue()) >= 0;
    } else if(device == 'md') {
      return ['lg', 'xl'].indexOf(this.deviceSubject.getValue()) >= 0;
    } else if(device == 'lg') {
      return ['xl'].indexOf(this.deviceSubject.getValue()) >= 0;
    } else {
      return false;
    }
  }

  public gte(device: string): boolean {
    return this.deviceSubject.getValue() == device || this.gt(device);
  }

  public lt(device: string): boolean {
    if(device == 'xl') {
      return ['sm', 'md', 'lg'].indexOf(this.deviceSubject.getValue()) >= 0;
    } else if(device == 'lg') {
      return ['sm', 'md'].indexOf(this.deviceSubject.getValue()) >= 0;
    } else if(device == 'md') {
      return ['sm'].indexOf(this.deviceSubject.getValue()) >= 0;
    } else {
      return false;
    }
  }

  public lte(device: string) {
    return this.deviceSubject.getValue() == device || this.lt(device);
  }
}
